import type React from "react";
import { forwardRef } from "react";
import type {
  IStreamData,
  IThumbnailTemplate,
} from "../../../../../types/thumbnail-template";
import FuneralTemplate from "./FuneralTemplate";
import ConferenceTemplate from "./ConferenceTemplate";

export interface TemplateRendererProps {
  streamData: IStreamData;
  template: IThumbnailTemplate;
  style?: React.CSSProperties;
  customBackground?: string;
}

const TemplateRenderer = forwardRef<HTMLDivElement, TemplateRendererProps>(
  ({ streamData, template, style, customBackground }, ref) => {
    const bookingType = streamData?.bookingData?.booking_type;

    const shouldUseConferenceTemplate =
      bookingType === "CONFERENCE" ||
      bookingType === "CHURCH" ||
      template.category === "conference";

    if (shouldUseConferenceTemplate) {
      return (
        <ConferenceTemplate
          ref={ref}
          streamData={streamData}
          template={template}
          style={style}
          customBackground={customBackground}
        />
      );
    }

    return (
      <FuneralTemplate
        ref={ref}
        streamData={streamData}
        template={template}
        style={style}
      />
    );
  },
);

TemplateRenderer.displayName = "TemplateRenderer";
export default TemplateRenderer;
